// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__69VlS","map_title_style":"MapPOIS_map_title_style__2SEy0"};